import type { ApiResponse } from './api';

// Event Type Enum for data integration
export enum EventType {
  DATA_UPDATE = 'DATA_UPDATE',
  THRESHOLD_EXCEEDED = 'THRESHOLD_EXCEEDED',
  ANOMALY_DETECTED = 'ANOMALY_DETECTED',
  DEVICE_STATUS = 'DEVICE_STATUS',
  SYSTEM_STATUS = 'SYSTEM_STATUS'
}

// Event Types
export interface Event {
  id: number;
  pool_id: number;
  type: 'maintenance' | 'inspection' | 'incident' | 'training' | 'other';
  title: string;
  description: string;
  start_time: string;
  end_time: string;
  status: 'scheduled' | 'in_progress' | 'completed' | 'cancelled';
  priority: 'low' | 'medium' | 'high' | 'critical';
  assigned_to: number[];
  location: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

// Event Filter Types
export interface EventFilter {
  pool_id?: number;
  type?: 'maintenance' | 'inspection' | 'incident' | 'training' | 'other';
  status?: 'scheduled' | 'in_progress' | 'completed' | 'cancelled';
  priority?: 'low' | 'medium' | 'high' | 'critical';
  assigned_to?: number[];
  start_time?: string;
  end_time?: string;
  search?: string;
}

// Event Creation Types
export interface EventCreate {
  pool_id: number;
  type: 'maintenance' | 'inspection' | 'incident' | 'training' | 'other';
  title: string;
  description: string;
  start_time: string;
  end_time: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  assigned_to: number[];
  location: string;
  notes?: string;
}

// Event Update Types
export interface EventUpdate {
  type?: 'maintenance' | 'inspection' | 'incident' | 'training' | 'other';
  title?: string;
  description?: string;
  start_time?: string;
  end_time?: string;
  status?: 'scheduled' | 'in_progress' | 'completed' | 'cancelled';
  priority?: 'low' | 'medium' | 'high' | 'critical';
  assigned_to?: number[];
  location?: string;
  notes?: string;
}

// Event API Interface
export interface IEventApi {
  getEvents: (filter?: EventFilter) => Promise<ApiResponse<Event[]>>;
  getEvent: (id: number) => Promise<ApiResponse<Event>>;
  createEvent: (data: EventCreate) => Promise<ApiResponse<Event>>;
  updateEvent: (id: number, data: EventUpdate) => Promise<ApiResponse<Event>>;
  deleteEvent: (id: number) => Promise<ApiResponse<void>>;
  startEvent: (id: number) => Promise<ApiResponse<Event>>;
  completeEvent: (id: number) => Promise<ApiResponse<Event>>;
  cancelEvent: (id: number) => Promise<ApiResponse<Event>>;
} 